import { render, staticRenderFns } from "./WCConfirmDialog.vue?vue&type=template&id=5c5f1fbc&"
import script from "./WCConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./WCConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports